import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getSingleObjection } from "store/actions";
import Loader from "components/shared/Loader";

const ShowObjection = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loading, singleObjection } = useSelector((state) => state.objections);

  useEffect(() => {
    dispatch(getSingleObjection(id));
  }, [dispatch, id]);

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card job-details">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"showObjectionRequest"} />
          </h4>
        </div>
        <div className="card-body table-details--">
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <FormattedMessage id={"name"} />
                  </td>
                  <td>{singleObjection?.fullName} </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"nationalId"} />
                  </td>
                  <td>{singleObjection?.nationalId} </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"phone"} />
                  </td>
                  <td>{singleObjection?.phone}</td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"email"} />
                  </td>
                  <td>{singleObjection?.email} </td>
                </tr>

                <tr>
                  <td>
                    <FormattedMessage id={"city"} />
                  </td>
                  <td>{singleObjection?.city} </td>
                </tr>

                <tr>
                  <td>
                    <FormattedMessage id={"area"} />
                  </td>
                  <td>{singleObjection?.area} </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"instrumentNumber"} />
                  </td>
                  <td>{singleObjection?.instrumentNumber} </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"landLink"} />
                  </td>
                  <td>
                    <NavLink to={singleObjection?.landLink} target="_blank">
                      {singleObjection?.landLink}
                    </NavLink>
                  </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"landImage"} />
                  </td>
                  <td>
                    <NavLink to={singleObjection?.landImage} target="_blank">
                      <img src={singleObjection?.landImage} alt="" />
                    </NavLink>
                  </td>
                </tr>
                <tr>
                  <td>
                    <FormattedMessage id={"authorizationFile"} />
                  </td>
                  <td>
                    <NavLink
                      to={singleObjection?.authorizationFile}
                      target="_blank"
                    >
                      <img src={singleObjection?.authorizationFile} alt="" />
                    </NavLink>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowObjection;
